import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import {
  Smartphone,
  ShoppingBasket,
  Settings,
  CheckCircle,
  Truck,
  Headphones,
  Waves,
  FlaskConical,
  Calendar
} from 'lucide-react';

import './HowtoworkSecond.css';

const steps = [
  { step: 1, title: "Order on the App", text: "Tap. Select. Done. Your pickup is booked in seconds.", icon: <Smartphone /> },
  { step: 2, title: "Prepare Your Items", text: "Gather your garments. We bring the bags. You just hand them over.", icon: <ShoppingBasket /> },
  { step: 3, title: "World-Class Facility", text: "Every item cleaned on commercial-grade equipment, tracked by QR, finished by specialists.", icon: <Settings /> },
  { step: 4, title: "Quality Checked", text: "Every piece inspected before it leaves us — creases, colour, fasteners.", icon: <CheckCircle /> },
  { step: 5, title: "Back Tomorrow", text: "Next-day delivery available. Cleaned, pressed, and at your door.", icon: <Truck /> },
];

const HowtoWorkSecond = () => {
  return (
    <>
      {/* HOW IT WORKS */}
      <section className="how-section py-5 my-5">
        <Container>

          <div className="text-center mb-5">
            <h2 className="section-title">
              Your Laundry. Our Process. Perfected.
            </h2>
            <div className="section-divider mx-auto"></div>
          </div>

          <Row className="g-4">
            {steps.map((item, idx) => (
              <Col key={idx} xs={12} sm={6} lg={4} className="d-flex">
                
                <Card
                  className="step-card w-100 border-0 shadow-sm"
                  style={{ animationDelay: `${idx * 0.15}s` }}
                >
                  <div className="step-content">

                    <div className="step-number">
                      {item.step}
                    </div>

                    <div className="step-icon">
                      {React.cloneElement(item.icon, { size: 24 })}
                    </div>

                    <h5 className="step-title">
                      {item.title}
                    </h5>

                    <p className="step-text">
                      {item.text}
                    </p>

                  </div>
                </Card>

              </Col>
            ))}
          </Row>

        </Container>
      </section>

      {/* HEADING */}


      <Row className="text-center my-5">
        <Col>
                 <h2 className="expertise-title">
    25+ Years of Laundry Expertise <br />
    Ready to Serve You
  </h2>

  <p className="expertise-subtitle">
    We still treat every order like it matters.
  </p>
        </Col>
      </Row>

      {/* FEATURES */}
      <section className="bg-soft-blue py-5">
        <Container>
          <Row className="g-4">

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><Headphones /></div>
                <h4>Always Reachable. Always Ready.</h4>
                <p>App, WhatsApp, toll-free, live chat, or in-store — pick your channel, we'll handle the rest.</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><CheckCircle /></div>
                <h4>World-Class Facility & Equipment</h4>
                <p>State-of-the-art machinery, Controlled temperatures, Precision finishing - it is a facility </p>
              </div>
            </Col>

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><Settings /></div>
                <h4>Specialist Care for Every Garment</h4>
                <p>Kandora, Abaya, Sheila, suits, sneakers, wedding gowns — each treated by the right process, not a one-size-fits-all machine</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><Waves /></div>
                <h4>Fabric-Safe Chemistry</h4>
                <p>Right detergent, right temperature, right process. No shrinkage, no damage, no surprises.</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><FlaskConical /></div>
                <h4>Flexible Pickup & Delivery</h4>
                <p>You set the time. We show up. Built around your schedule, not ours.</p>
              </div>
            </Col>

            <Col md={4}>
              <div className="feature-card">
                <div className="icon-circle"><Calendar /></div>
                <h4>Flexible Delivery</h4>
                <p>You choose time, we deliver on schedule.</p>
              </div>
            </Col>

          </Row>
        </Container>
      </section>
    </>
  );
};

export default HowtoWorkSecond;